import { BaseEnumModel } from "@edaz/services/baseEnumService";

export interface IEnum extends BaseEnumModel {
  name?: string;
  code?: string;
}

export default class Enum implements IEnum {
  id: number | string;
  code?: string;
  name?: string;
}
